module.exports = {
	"articleTitle1": "Michigan Stadium concessions manager fined thousands in state ...",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Michigan Stadium",
	"articleLink2": "https://www.michigandaily.com/sports/michigan-stadium-real-madrid-manchester-united-august-champions",
	"articleSnippet1": "Mar 28, 2017 ... Following of liquor-control violations at the International Champions Cup soccer \ngame played at Michigan Stadium on July 30, 2016, the ...",
	"articleSnippet2": "Feb 20, 2014 ... 2 at Michigan Stadium. Currently, the International Champions Cup website lists \na game between them at a venue and time “to be determined.”.",
	"totalMisc": 0,
	"articleTitle2": "Michigan Stadium",
	"address": "1201 S Main St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/161107/agc.FBC_.vsMaryland.11.5.16.0693.jpg?itok=vip9_Zd7",
			"author": "Amelia Cacchione",
			"caption": "Wilton Speight was one of Michigan's highlights Saturday against Maryland."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170412/zqh.FBC_.vsIllinois.10.22.16.037A.jpg?itok=Y6uKrRRp",
			"author": "Zoey Holmstrom",
			"caption": "Sophomore running back Eddie McDoom seems poised for a breakout campaign in his second year."
		}
	],
	"position": {
		"lat": 42.2658,
		"lng": -83.7487
	},
	"tips": [
		{
			"text": "Biggest stadium in the nation. Need I say more?",
			"person": "Erik Forkin"
		},
		{
			"text": "Don't expect to get any service/wifi in there",
			"person": "Bob Lesser"
		}
	],
	"articleLink1": "https://www.michigandaily.com/section/crime/michigan-stadium-concessions-manager-fined-thousands-state-liquor-violations",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/michiganstadium.json
// module id = 920
// module chunks = 0